<template>
    <div class="flex flex-col md:flex-row md:items-end w-full justify-between">
        <div class="style-emph ">
            {{ title }}
        </div>
        <div class="mt-4 md:mt-0">
            <div class="flex border border-blue-gray rounded-3xl pl-5 pr-5 py-1 py-2 items-center">
                <input @change="reloadItems" v-model="searchString" type="text" placeholder="Search with serial no."
                       class="w-full md:w-56 text-sm font-light bg-transparent outline-none"> <i
                    class="far fa-search text-blue-gray"></i>
            </div>
        </div>
    </div>

    <div class="bg-white shadow-100 rounded-xl mt-4">
        <div class="equipment-row grid-cols-1 md:grid-cols-10 items-center hidden md:grid py-3 px-7">
            <div class="style-title-1">
                ID
            </div>
            <div class="style-title-1 md:col-span-2">
                Type
            </div>
            <div class="style-title-1">
                Model
            </div>
            <div class="style-title-1 md:col-span-3">
                Location
            </div>
            <div class="style-title-1 md:col-span-2">
                Serial
            </div>
            <div></div>
        </div>
        <div v-for="equipment in equipments"
             class="equipment-row grid grid-cols-1 md:grid-cols-10 items-center py-5 px-7" :key="equipment.id">
            <div class="py-1 flex">
                <div class="style-title-1 w-1/4 text-right mr-3 md:hidden">
                    ID:
                </div>
                <div>
                    {{equipment.id}}
                </div>
            </div>
            <div class="py-1 flex md:col-span-2">
                <div class="style-title-1 w-1/4 text-right mr-3 md:hidden">
                    Type:
                </div>
                <div>
                    {{equipment.type}}
                </div>
            </div>

            <div class="py-1 flex">
                <div class="style-title-1 w-1/4 text-right mr-3 md:hidden">
                    Model:
                </div>
                <div>
                    {{equipment.model}}
                </div>
            </div>

            <div class="py-1 flex md:col-span-3">
                <div class="style-title-1 w-1/4 text-right mr-3 md:hidden">
                    Location:
                </div>
                <div>
                    {{equipment.location}}
                </div>
            </div>

            <div class="py-1 flex md:col-span-2">
                <div class="style-title-1 w-1/4 text-right mr-3 md:hidden">
                    Serial:
                </div>
                <div>
                    {{equipment.serial}}
                </div>
            </div>

            <div class="text-right mt-4 md:mt-0">

                <toggle-menu>
                    <div @click="goToBookServiceCall(equipment)" class="py-1 px-4 flex items-center style-body font-light cursor-pointer hover:bg-gray">
                        <i class="far fa-wrench text-lg mr-3 "></i> Request Service Call
                    </div>

                    <div @click="goToOrderConsumables(equipment)" class="py-1 px-4 flex items-center style-body font-light cursor-pointer hover:bg-gray">
                        <i class="far fa-tint text-lg mr-3 "></i> Order Product Consumables
                    </div>

                    <div @click="goToMeterReadings(equipment)" class="py-1 px-4 flex items-center style-body font-light cursor-pointer hover:bg-gray">
                        <i class="far fa-print text-lg mr-3 "></i> Update Meter Readings
                    </div>
                </toggle-menu>
            </div>
        </div>
    </div>


    <div class="text-center mt-5" :class="{hidden: !loading}">
        <loading></loading>
    </div>

    <div class="text-center mt-8" :class="{hidden: !partial}">
        <a @click="loadMore" class="btn">Load More</a>
    </div>

</template>

<script charset="utf-8">

import Loading from './Loading.vue';
import ToggleMenu from './ToggleMenu.vue';
import Vuex from 'vuex';

export default {
    name: 'AdminEquipmentGrid',
    props: ['title', 'toAddress'],
    data() {
        return {
            curPage: 0,
            loading: true,
            searchString: ''
        }
    },
    computed: {
        ...Vuex.mapGetters('equipments', {
            equipments: 'items',
            partial: 'partial'
        }),
        ...Vuex.mapGetters('profile', {
            profile: 'profile'
        }),
    },
    created() {
        this.loadItems();
    },
    components: {
        Loading,
        ToggleMenu
    },
    emits: ["select"],
    methods: {
        ...Vuex.mapActions('equipments', {
            getAdminItems: 'getAdminItems'
        }),
        loadMore(){
            this.curPage++;
            this.loadItems();
        },
        reloadItems(){
            this.curPage = 0;
            this.loadItems();
        },
        loadItems(){
            this.loading = true;
            this.getAdminItems({
                clientID: this.$router.currentRoute.value.params.clientID,
                page: this.curPage,
                searchString: this.searchString
            }).then(() => {
                this.loading = false;
            });
        },
        select(equipment) {
            this.$emit('select', equipment);
        },
        goToBookServiceCall(equipment){
            if(this.profile.isSharpAdmin()){
                this.$router.push({ name: 'adminBookServiceCall', query: { war_id: equipment.id, serial: equipment.serial } });
            }else{
                this.$router.push({ name: 'groupAdminBookServiceCall', query: { war_id: equipment.id, serial: equipment.serial } });
            }
        },
        goToOrderConsumables(equipment){
            if(this.profile.isSharpAdmin()){
                this.$router.push({ name: 'adminOrderConsumables', query: { war_id: equipment.id, serial: equipment.serial } });
            }else{
                this.$router.push({ name: 'groupAdminOrderConsumables', query: { war_id: equipment.id, serial: equipment.serial } });
            }
        },
        goToMeterReadings(equipment){
            if(this.profile.isSharpAdmin()){
                this.$router.push({ name: 'adminMeterReadings', query: { war_id: equipment.id, serial: equipment.serial } });
            }else{
                this.$router.push({ name: 'groupAdminMeterReadings', query: { war_id: equipment.id, serial: equipment.serial } });
            }
        }
    }
}
</script>
